var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.063,
    height: 13.436,
    viewBox: "0 0 19.063 13.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.461,17.106a2.9,2.9,0,1,1,2.9-2.9A2.9,2.9,0,0,1,12.461,17.106Zm0-4.419a1.519,1.519,0,1,0,1.519,1.519A1.519,1.519,0,0,0,12.461,12.687ZM16.6,18.244a.691.691,0,0,1-.486-1.177,4.055,4.055,0,0,0,0-5.723.691.691,0,1,1,.978-.972,5.43,5.43,0,0,1,0,7.667A.679.679,0,0,1,16.6,18.244Zm-8.286.006a.7.7,0,0,1-.492-.2,5.436,5.436,0,0,1,0-7.673.691.691,0,1,1,.978.978,4.049,4.049,0,0,0,0,5.717.691.691,0,0,1,0,.978A.7.7,0,0,1,8.317,18.25Z",
    transform: "translate(-2.917 -7.488)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.015,18.774a.691.691,0,0,1-.691-.691.718.718,0,0,1,.21-.5,7.607,7.607,0,0,0,0-11.048.691.691,0,0,1,.961-.994,8.982,8.982,0,0,1,0,13.015A.674.674,0,0,1,16.015,18.774Zm-12.5,0a.685.685,0,0,1-.552-.243,8.988,8.988,0,0,1,.072-13A.691.691,0,0,1,4,6.527,7.607,7.607,0,0,0,4,17.575a.7.7,0,0,1-.481,1.2Z",
    transform: "translate(-0.223 -5.338)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLive);
export default __webpack_public_path__ + "static/media/newLive.ae2d4514480e4f3b971db17c5e232bfe.svg";
export { ForwardRef as ReactComponent };